import { Link } from 'react-router-dom';
import { productConfig } from '@shared/config';
import { cn } from '@/lib/cn';
import { RocketMark } from './rocket-mark';

export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cn('brand-mark', className)} aria-hidden="true">
      <RocketMark />
    </span>
  );
}

export function BrandLogo({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <Link
      to="/"
      className={cn('brand-logo focus-ring', className)}
      aria-label={`${productConfig.brandName} home`}
    >
      <BrandMark />
      {!compact && (
        <span className="brand-wordmark">
          Careers<span>Launching</span>
        </span>
      )}
    </Link>
  );
}
